<template>
  <div class="item-course">
    <div class="cover">
      <img :src="item.cover_img" />
    </div>
    <div class="name">{{ item.course_name }}</div>
    <div class="bottom">
      <span class="integral-wrap">
        <span class="integral">{{ item.exchange_price }}</span>
        <span class="integral-label">
          {{ $store.state.commonSetting.point_info.point_name }}
        </span>
      </span>
      <router-link
        class="lnk-exchange"
        :to="{ name: 'IntegralGoodsDetail', params: { id: item.id } }"
      >
        去兑换
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntegralCourseItem",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
<style scoped lang="scss">
.item-course {
  margin-right: 5px;
  margin-bottom: 20px;
  width: 258px;
  float: left;
  padding: 15px 20px;

  &:hover {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 12px 34px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  &:nth-child(3n) {
    margin-right: 0;
  }

  &:nth-child(3n + 1) {
    margin-left: 5px;
  }

  .cover {
    height: 151px;
    margin-bottom: 15px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }

  .name {
    height: 52px;
    font-size: 19px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(89, 89, 89, 1);
    line-height: 26px;
    overflow: hidden;
    margin-bottom: 30px;
  }

  .period {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    line-height: 20px;
    margin-bottom: 20px;
  }

  .period-count {
    margin: 0 5px;
  }

  .teachers {
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 15px;
  }

  .teacher {
    margin-right: 25px;
    text-align: center;
  }

  .teacher-avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    margin-bottom: 8px;
  }

  .teacher-name {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 20px;
    width: 45px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .integral-wrap {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(238, 31, 31, 1);
      display: flex;
      height: 32px;
    }

    .integral {
      font-size: 24px;
      line-height: 32px;
    }

    .integral-label {
      font-size: 15px;
      line-height: 34px;
    }

    .lnk-exchange {
      width: 74px;
      height: 32px;
      background: rgba(255, 255, 255, 1);
      border-radius: 16px;
      border: 1px solid rgba(210, 210, 210, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(89, 89, 89, 1);
      line-height: 32px;
      text-align: center;
    }
  }
}
</style>
